<template>
	<div class="parts-locations-general-card-edit">
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Shared Settings</h4>
			</template>
			<template #content>
				<Dropdown
					label="Part Cost Default Visibility"
					subLabel="Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs."
					v-model="
						localData.sharedSettings.partsCostDefaultVisibility
					"
					:options="partsCostDefaultVisibilityTypeOptions"
				/>
				<Dropdown
					label="Default Account Code"
					subLabel="Lorem Ipsum Affects Parts Invoice and Parts desk."
					v-model="localData.sharedSettings.defaultAccountCode"
					:options="defaultAccountCodeTypeOptions"
				/>
				<Input
					label="Minimum GP% Repair Order"
					sublabel="Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs."
					v-model="localData.sharedSettings.minimunGPRO"
				/>
				<label for="verifyWarrantyPartsReceived">
					<span>Verify Warranty Parts Received</span>
					<span>Affects Repair Orders and Back Counter.</span>
				</label>
				<Toggle
					id="verifyWarrantyPartsReceived"
					v-model="localData.sharedSettings.verifyWarrPartsReceived"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
			</template>
		</SectionContainer>
		<!-- Gross Profit & Tax: Masking, Markups, Price Codes Section -->
		<SectionContainer>
			<template #left>
				<h4>Gross Profit & Tax: Masking, Markups, Price Codes</h4>
			</template>
			<template #content>
				<!-- Price Codes Subsection -->
				<div>
					<h4>Price Codes</h4>
					<!-- DEV NOTE: component to be created. Using input as placeholder -->
					<Input
						label="Default NPN Price Code"
						subLabel="Affects	Repair Orders and Back Counter."
						v-model="localData.priceCodes.defaultNPNPriceCode"
					/>
					<h5>Default Price Codes on Inventory</h5>
					<p>Affects Repair Orders and Back Counter</p>
					<Input
						label="Price Code 1"
						v-model="localData.priceCodes.priceCode1"
					/>
					<Input
						label="Price Code 2"
						v-model="localData.priceCodes.priceCode2"
					/>
					<Input
						label="Price Code 3"
						v-model="localData.priceCodes.priceCode3"
					/>
				</div>
				<!-- Masking Subsection -->
				<div>
					<h4>Masking</h4>
					<Input
						label="Mask Tenths"
						v-model="localData.masking.maskTenths"
					/>
					<Input
						label="Mask Hundredths"
						v-model="localData.masking.maskHundredths"
					/>
					<Input
						label="Minimum Price"
						v-model="localData.masking.minimumPrice"
					/>
					<Input
						label="Maximum Price"
						v-model="localData.masking.maximumPrice"
					/>
					<Checkbox
						labelText="RO - Client Pay"
						subLabel="Affects Repair Orders and Back Counter"
						v-model="localData.masking.roCustomerPay"
					/>
					<Checkbox
						labelText="RO - Internal Pay"
						subLabel="Affects Repair Orders and Back Counter"
						v-model="localData.masking.roInternalPay"
					/>
					<Checkbox
						labelText="Apply to Wholesale"
						subLabel="Affects Repair Orders and Back Counter"
						v-model="localData.masking.applyToWholesale"
					/>
					<Checkbox
						labelText="Apply to Invoice"
						subLabel="Affects Repair Orders and Back Counter"
						v-model="localData.masking.applyToInvoice"
					/>
				</div>
				<!-- Tax Subsection -->
				<div>
					<h4>Tax</h4>
					<Dropdown
						label="Core Charge Tax"
						subLabel="Placeholder Text Lorem Epsom"
						v-model="localData.tax.coreChargeTax"
						:options="coreChargeTaxTypeOptions"
					/>
				</div>
				<!-- Markups Subsection -->
				<div>
					<h4>Markup</h4>
					<Input
						labelText="Wholesale Markup"
						subLabel="Affects Repair Orders and Back Counter."
						v-model="localData.tax.wholesaleMarkup"
					/>
					<Input
						labelText="Retail Markup"
						subLabel="Affects Repair Orders and Back Counter."
						v-model="localData.tax.retailMarkup"
					/>
				</div>
			</template>
		</SectionContainer>
		<!-- Integrations Section -->
		<SectionContainer>
			<template #left>
				<h4>Integrations</h4>
			</template>
			<template #content>
				<!-- MyPrice Link Section -->
				<div>
					<label for="myPriceLink">
						<span>
							MyPrice Link
						</span>
						<span>
							Lorem Affects Repair Orders and Back Counter.
						</span>
					</label>
					<Toggle
						id="myPriceLink"
						v-model="localData.integrations.priceLink"
						:isLabelBefore="true"
					>
						<template slot="true-value">YES</template>
						<template slot="false-value">NO</template>
					</Toggle>
				</div>
				<!-- EPC Provider and Manufacturer Section -->
				<div>
					<h4>EPC Provider and manufacturer</h4>
					<ul>
						<li
							v-for="(item,
							index) in localData.epcProviderAndManufacturer"
							:key="index"
						>
							<Dropdown
								v-model="item.provider"
								:options="providerTypeOptions"
							/>
							<Dropdown
								v-model="item.manufacturer"
								:options="manufacturerTypeOptions"
							/>
							<Button
								labelText="Delete"
								iconClassName="icon-history"
								:iconBeforeLabel="true"
							/>
						</li>
					</ul>
					<Button
						labelText="Add"
						iconClassName="icon-history"
						:iconBeforeLabel="true"
					/>
				</div>
			</template>
		</SectionContainer>
		<!-- Inventory Section -->
		<SectionContainer>
			<template #left>
				<h4>Inventory</h4>
			</template>
			<template #content>
				<Input label="Default Bin" v-model="localData.defaultBin" />
				<Dropdown
					label="Physical Inventory Index"
					subLabel="Lorem Parts, Parts desk, Back Counter, and ROs"
					v-model="localData.inventory.physicalInventoryIndex"
					:options="physicalInventoryIndexTypeOptions"
				/>
				<Dropdown
					label="Part OHQ"
					subLabel="Lorem Parts, Parts desk, Back Counter, and ROs"
					v-model="localData.inventory.partOHQAlert"
					:options="partOHQAlertTypeOptions"
				/>
				<label for="orderSourcePrompt">
					<span>Order Source Prompt</span>
				</label>
				<Toggle
					id="orderSourcePrompt"
					v-model="localData.inventory.orderSourcePrompt"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
				<label for="orderSourcePrompt">
					<span>Search Part Base</span>
				</label>
				<Toggle
					id="orderSourcePrompt"
					v-model="localData.inventory.searchPartBasePrompt"
					:isLabelBefore="true"
				>
					<template slot="true-value">YES</template>
					<template slot="false-value">NO</template>
				</Toggle>
			</template>
		</SectionContainer>
		<!-- Parts Desk Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Desk</h4>
			</template>
			<template #content>
				<!-- DEV NOTE: replace when inline edit component is ready -->
				<Input
					label="Next Part Desk"
					subLabel="Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs"
					v-model="localData.partsDesk.nextPartsDesk"
				/>
				<Input
					label="Desk Expiration Days"
					v-model="localData.partsDesk.deskExpirationDays"
				/>
			</template>
		</SectionContainer>
		<!-- Parts Invoice Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice Client #</h4>
			</template>
			<template #content>
				<!-- DEV NOTE: replace when proper component is ready -->
				<Input
					label="Parts Invoice Client #"
					v-model="localData.partsInvoice.partsInvoiceCustomer"
				/>
				<!-- DEV NOTE: replace when inline-edit component is ready -->
				<Input
					label="Next Part Invoice"
					subLabel="Edit, alpha numeric and attempting to Save - Numeric only"
					v-model="localData.partsInvoice.nextPartsInvoice"
				/>
				<Input
					label="Minmum GP% Invoice"
					subLabel="Lorem Ipsum Parts, Parts Desk, Back Counter, and ROs"
					v-model="localData.partsInvoice.minGPInvoice"
				/>
				<Dropdown
					label="Auto Pay Cash"
					subLabel="Lorem Parts, Parts desk, Back Counter, and ROs"
					v-model="localData.partsInvoice.autoPayCash"
					:options="autoPayCashTypeOptions"
				/>
				<Dropdown
					label="Auto Pay Charge"
					subLabel="Lorem Parts, Parts desk, Back Counter, and ROs"
					v-model="localData.partsInvoice.autoPayCharge"
					:options="autoPayChargeTypeOptions"
				/>
			</template>
		</SectionContainer>
		<!-- Special Orders Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice Client #</h4>
			</template>
			<template #content>
				<Dropdown
					label="Parts Order Comment Type"
					v-model="localData.specialOrders.partsOrderCommentType"
					:options="partsOrderCommentTypeTypeOptions"
				/>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import Input from '@/components/forms/input/input';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
import Button from '@/components/forms/button/button';
import SectionContainer from '@/components/shells/section-container/section-container';
import _ from 'lodash';

export default {
	name: 'PartsLocationsGeneralCardEdit',
	components: { SectionContainer, Dropdown, Input, Toggle, Checkbox, Button },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			partsCostDefaultVisibilityTypeOptions: [
				'Parts',
				'Parts Desk',
				'Back Counter',
				'ROs'
			],
			defaultAccountCodeTypeOptions: ['Parts', 'Invoice', 'Parts Desk'],
			coreChargeTaxTypeOptions: ['lorem', 'ipsum', 'dolor'],
			providerTypeOptions: ['lorem', 'ipsum'],
			manufacturerTypeOptions: ['kia', 'gmc', 'ford'],
			physicalInventoryIndexTypeOptions: [0, 1, 2, 3, 4, 5],
			partOHQAlertTypeOptions: ['All Tickets', 'lorem', 'ipsum'],
			autoPayCashTypeOptions: ['lorem', 'ipsum'],
			autoPayChargeTypeOptions: ['lorem', 'ipsum'],
			partsOrderCommentTypeTypeOptions: ['lorem', 'ipsum']
		};
	},
	created() {
		//console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card-edit {
	&__item {
		display: block;
	}
}
</style>
